import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { Cards } from '../..';
export const _frontmatter = {
  "title": "Guides"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "guides"
    }}>{`Guides`}</h1>
    <Cards width={320} mdxType="Cards">
      <ul>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/guides/how-it-works"
          }}>{`How it Works`}</a>{`
Implementation details for the core library`}</li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/guides/jsx-pragma"
          }}>{`JSX Pragma`}</a>{`
Using JSX pragma to enable the `}<inlineCode parentName="li">{`sx`}</inlineCode>{` prop`}</li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/guides/motivation"
          }}>{`Motivation`}</a>{`
Project background and prior art`}</li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/guides/object-styles"
          }}>{`Object Styles`}</a>{`
Authoring styles with object literal syntax`}</li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/guides/variants"
          }}>{`Variants`}</a>{`
Create stylistic theme-based variations`}</li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/guides/layouts"
          }}>{`Layouts`}</a>{`
Creating themeable page layouts`}</li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/guides/styled-components"
          }}>{`Styled Components`}</a>{`
Create reusable styled components`}</li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/guides/mdx-layout-components"
          }}>{`MDX Layout Components`}</a>{`
Use Theme UI to create MDX layouts`}</li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/guides/responsive-typography"
          }}>{`Responsive Typography`}</a>{`
Style content responsively`}</li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/guides/nested-theme-providers"
          }}>{`Nested ThemeProviders`}</a>{`
Add contextual theme and stylistic changes`}</li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/guides/custom-cache-provider"
          }}>{`Custom CacheProvider`}</a>{`
Customise the styles generated and where they are injected`}</li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/guides/syntax-highlighting"
          }}>{`Syntax Highlighting`}</a>{`
Add syntax highlighting to MDX code blocks`}</li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/guides/theme-color-meta-tag"
          }}>{`Theme Color Meta Tag`}</a>{`
Use theme colors for the theme color meta tag`}</li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/guides/color-mode-toggles"
          }}>{`Color Mode Toggles`}</a>{`
Create buttons to switch color modes`}</li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/guides/global-styles"
          }}>{`Global Styles`}</a>{`
Add global styles with Emotion`}</li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/guides/linked-headings"
          }}>{`Linked Headings`}</a>{`
Add linked headings in MDX`}</li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/guides/using-theme-ui-without-mdx"
          }}>{`Using Theme UI without MDX`}</a>{`
Use the core package to avoid unnecessary bloat`}</li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/guides/merging-themes"
          }}>{`Merging Themes`}</a>{`
Merging theme objects together with JavaScript`}</li>
      </ul>
    </Cards>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      